const BHSlider = {
	BHSlider: {
		defaultProps: {
			imageSizeMd: 50,
			imageSizeXs: 100,
		},
	},
}

export default BHSlider
